import { useEffect, useRef, useState } from 'react';
import { cleanText, normalizeText } from './utils';

type DetectData = {
  ref: HTMLElement | null;
  text: string;
};

export const useDetectTranslatorForContent = (
  data: DetectData[],
  deps?: string,
) => {
  const [isTranslated, setIsTranslated] = useState(false);
  const prevValueRef = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      let detected = false;

      for (const { ref, text } of data) {
        if (!ref?.innerText || !text) continue;

        const domText = normalizeText(cleanText(ref.innerText));
        const originalText = normalizeText(cleanText(text));

        if (domText !== originalText) {
          detected = true;
          break; 
        }
      }

      if (prevValueRef.current !== detected) {
        prevValueRef.current = detected;
        setIsTranslated(detected);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [data]);

  useEffect(() => {
    prevValueRef.current = false;
    setIsTranslated(false);
  }, [deps]);

  return isTranslated;
};
